import React from "react";
import { useTranslation } from "react-i18next";

const SectionOptionEdit = ({ formData, setFormData }) => {
  const { t } = useTranslation();

  // 🔹 Fonction pour gérer le changement d'option (true/false)
  const handleOptionChange = (key, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
  };

  // 🔹 Liste des options à afficher
  const options = [
    { key: "parking", label: t("options.parking") },
    { key: "meuble", label: t("options.furnished") },
    { key: "wifi", label: t("options.wifi") },
    { key: "tv", label: t("options.tv") },
    { key: "washer", label: t("options.lavelinge") },
    { key: "kitchen", label: t("options.cuisine") },
    { key: "AC", label: t("options.climatisation") },
    { key: "piscine", label: t("options.picine") },
    { key: "garden", label: t("options.jardin") },
    { key: "barbecue", label: t("options.barbecue") },
    { key: "beachAccess", label: t("options.accesauplage") },
    { key: "workspace", label: t("options.espacedetravail") },
  ];

  return (
    <div className="mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {options.map(({ key, label }) => (
          <div key={key}>
            <label className="block text-lg font-semibold">{label}</label>
            <div className="flex items-center space-x-4">
              <button
                type="button"
                onClick={() => handleOptionChange(key, true)}
                className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                  formData[key] || false ? "bg-slate-600 text-white" : "bg-white text-black"
                }`}
              >
                {t("yes")}
              </button>
              <button
                type="button"
                onClick={() => handleOptionChange(key, false)}
                className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                  !formData[key] || false ? "bg-slate-600 text-white" : "bg-white text-black"
                }`}
              >
                {t("non")}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionOptionEdit;
